module.exports = __webpack_public_path__ + "static/media/codeBar.d44da984.png";